import { Injectable } from '@angular/core';

import { loggerCreate } from '@blaze-shared/logger-util';

const logBlazeTable = loggerCreate('blaze_table', 'info', 'BlazeTableLoggerService', 'log');

@Injectable({ providedIn: 'root' })
export class BlazeTableLoggerService {
  log(...args: any[]): void {
    logBlazeTable((tag) => {
      console.log(
        `${tag} %c[⚡ Table]`,
        'background: #000; color: #ffff00; font-weight: 800',
        ...args,
      );
    });
  }

  error(...args: any[]): void {
    console.error('%c[⚡ Table]', 'background: #000; color: #ff0000; font-weight: 800', ...args);
  }
}
